import React, { useCallback } from "react";
import config from "../../config";
import fetchService from "../../lib/fetchService";
import { FunctionField } from "react-admin";

/**
 *
 * @param children the button content. done like this, to enable customizing how the button is rendered
 * @param labelType "shipments" or "models"
 * @param objectId the id of the shipment or model to print the label for
 * @param style additional style properties for the div wrapping the children
 * @param props
 * @returns {React.JSX.Element}
 * @constructor
 */
const PrintLabelButton = ({ children, labelType, objectId, style, ...props }) => {
  const fetchLabelIframe = useCallback(() => {
    const url = `${config.urls.BACKEND}/${labelType}/${objectId}/label`;
    try {
      const headers = new Headers();
      headers.append("Content-Type", "text/html; charset=utf-8");
      headers.append("Accept", "text/html");
      fetchService
        .get(url, undefined, headers)
        .then(response => {
          if (response.ok) return response.text();
          return undefined;
        })
        .then(html => {
          if (html) {
            const blob = new Blob(
              [html.replaceAll("label_template.png", `${config.urls.BACKEND}/static/images/label_template.png`)],
              { type: "text/html" }
            );
            const url = URL.createObjectURL(blob);
            window.open(url, "_blank");
            URL.revokeObjectURL(url);
          }
        })
        .catch(error => {
          throw error;
        });
    } catch (error) {
      throw new Error("Could not fetch label iframe.");
    } finally {
    }
  }, []);

  return (
    <>
      <FunctionField
        {...props}
        render={() => (
          <div style={{ all: "unset", cursor: "pointer", ...style }} onClick={fetchLabelIframe}>
            {children}
          </div>
        )}
      />
    </>
  );
};

export default PrintLabelButton;
